"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedInstrumentSelector = exports.selectedInstrumentProductsVLConfigSelector = exports.selectedInstrumentIdSelector = exports.selectSelectedL1InstrumentSelector = exports.level1Selector = exports.instrumentsWithProductFullNamesAndProductSymbols = exports.instrumentSelectorInstrumentsWithLevel1 = exports.instrumentSelectorInstruments = exports.instrumentSelectorEnabledInstruments = exports.instrumentPositionsSelector = exports.fetchingPositionsSelector = exports.buySellFormSelector = void 0;
var _reselect = require("reselect");
var _positionFormatter = _interopRequireDefault(require("../../helpers/positionFormatter"));
var _config = _interopRequireDefault(require("../../config"));
var _positionSelectors = require("./positionSelectors");
var _reduxForm = require("redux-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// export const level1Selector = createSelector(
//   level1,
//   level1Update,
//   (level1, level1Update) => {
//     const areEqual = _.isEqual( level1, level1Update );
//     debugger;
//     return {
//       level1: areEqual ? level1 : level1Update,
//     }
//   }
// );

var level1Selector = exports.level1Selector = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.level1;
}, function (level1) {
  return level1;
});
var getInstrumentsWithProductFullNamesAndProductSymbols = function getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product) {
  return instrument.instruments.filter(function (instrument) {
    var product1 = product.products.find(function (product) {
      return product.ProductId === instrument.Product1;
    });
    var product2 = product.products.find(function (product) {
      return product.ProductId === instrument.Product2;
    });
    return product1 && product2;
  }).map(function (instrument) {
    var product1 = product.products.find(function (product) {
      return product.ProductId === instrument.Product1;
    });
    var product2 = product.products.find(function (product) {
      return product.ProductId === instrument.Product2;
    });
    var _ref = product1 && product1,
      Product1Symbol = _ref.Product,
      Product1FullName = _ref.ProductFullName;
    var _ref2 = product2 && product2,
      Product2Symbol = _ref2.Product,
      Product2FullName = _ref2.ProductFullName;
    return _objectSpread(_objectSpread({}, instrument), {}, {
      Product1FullName: Product1FullName,
      Product2FullName: Product2FullName,
      Product1Symbol: Product1Symbol,
      Product2Symbol: Product2Symbol
    });
  });
};
var instrumentsWithProductFullNamesAndProductSymbols = exports.instrumentsWithProductFullNamesAndProductSymbols = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.instrument;
}, function (state) {
  return state.apexCore.product;
}, function (instrument, product) {
  return getInstrumentsWithProductFullNamesAndProductSymbols(instrument, product);
});
var instrumentSelectorInstruments = exports.instrumentSelectorInstruments = (0, _reselect.createSelector)(instrumentsWithProductFullNamesAndProductSymbols, function () {
  return _config["default"];
}, function (instruments, config) {
  if (config.InstrumentSelector.instruments.length === 0) {
    return instruments;
  }
  return instruments.filter(function (instrument) {
    return config.InstrumentSelector.instruments.includes(instrument.Symbol);
  });
});
var instrumentSelectorEnabledInstruments = exports.instrumentSelectorEnabledInstruments = (0, _reselect.createSelector)(instrumentSelectorInstruments, function (instruments) {
  return instruments.filter(function (instrument) {
    return !instrument.IsDisable;
  });
});
var instrumentSelectorInstrumentsWithLevel1 = exports.instrumentSelectorInstrumentsWithLevel1 = (0, _reselect.createSelector)(instrumentSelectorInstruments, level1Selector, function (instruments, level1) {
  var level = Object.values(level1);
  if (!(instruments !== null && instruments !== void 0 && instruments.length) || !(level !== null && level !== void 0 && level.length)) {
    return [];
  }
  return instruments.map(function (instrument) {
    return _objectSpread(_objectSpread({}, instrument), level.find(function (el) {
      return el.InstrumentId === instrument.InstrumentId;
    }));
  });
});
var selectedInstrumentIdSelector = exports.selectedInstrumentIdSelector = function selectedInstrumentIdSelector(state) {
  return state.apexCore.instrument.selectedInstrumentId;
};
var selectedInstrumentSelector = exports.selectedInstrumentSelector = (0, _reselect.createSelector)([instrumentsWithProductFullNamesAndProductSymbols, selectedInstrumentIdSelector], function (instruments, selectedInstrumentId) {
  return instruments.find(function (i) {
    return i.InstrumentId === selectedInstrumentId;
  }) || {};
});
var selectedInstrumentProductsVLConfigSelector = exports.selectedInstrumentProductsVLConfigSelector = (0, _reselect.createSelector)([selectedInstrumentSelector, function (state) {
  return state.user.verificationLevelConfigs;
}], function (selectedInstrument, verificationLevelConfigs) {
  var _verificationLevelCon, _verificationLevelCon2;
  var product1VLConfig = verificationLevelConfigs === null || verificationLevelConfigs === void 0 || (_verificationLevelCon = verificationLevelConfigs.Products) === null || _verificationLevelCon === void 0 ? void 0 : _verificationLevelCon.find(function (_ref3) {
    var ProductId = _ref3.ProductId;
    return ProductId === selectedInstrument.Product1;
  });
  var product2VLConfig = verificationLevelConfigs === null || verificationLevelConfigs === void 0 || (_verificationLevelCon2 = verificationLevelConfigs.Products) === null || _verificationLevelCon2 === void 0 ? void 0 : _verificationLevelCon2.find(function (_ref4) {
    var ProductId = _ref4.ProductId;
    return ProductId === selectedInstrument.Product2;
  });
  return {
    product1VLConfig: product1VLConfig,
    product2VLConfig: product2VLConfig
  };
});
var selectSelectedL1InstrumentSelector = exports.selectSelectedL1InstrumentSelector = (0, _reselect.createSelector)([selectedInstrumentSelector, function (state) {
  return state.apexCore.level1;
}], function (selectedInstrument, level1) {
  return selectedInstrument ? level1[selectedInstrument.InstrumentId] : '';
});
var instrumentPositionsSelector = exports.instrumentPositionsSelector = (0, _reselect.createSelector)([_positionSelectors.positionSelector, selectedInstrumentSelector], function (positions, instrument) {
  var position1 = (0, _positionFormatter["default"])(positions[instrument.Product1], instrument.Product1Symbol);
  var position2 = (0, _positionFormatter["default"])(positions[instrument.Product2], instrument.Product2Symbol);
  return {
    position1: position1,
    position2: position2
  };
});
var fetchingPositionsSelector = exports.fetchingPositionsSelector = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.position;
}, function (position) {
  return position.fetching;
});
var buySellFormSelector = exports.buySellFormSelector = (0, _reduxForm.formValueSelector)('buySell');